/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';

import {TextField, type Props as TextFieldProps} from '../textfield/textfield';
import {FormField} from '../form';

type OwnProps = {|
    title?: string,
    placeholder?: string,
    helperText?: string,
    multiline?: boolean,
    ...$Exact<TextFieldProps>,
|};

type Props = {...$Exact<FieldProps>, ...OwnProps};

export function ReduxFormTextField({title, helperText, input, meta, ...restProps}: Props) {
    return (
        <FormField
            innerId={input.name}
            label={title}
            helperText={helperText}
            errorMessage={meta.error && meta.submitFailed ? meta.error : null}
        >
            <TextField {...input} {...restProps} />
        </FormField>
    );
}
